import { Button } from "@/components/ui/button";
import { usePrivyCustom } from "@/lib/hooks/usePrivyCustom";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding/login")({
  component: Login,
});

function Login() {
  const { login, authenticated, user } = usePrivyCustom();
  const navigate = useNavigate();

  // // Redirect if already authenticated
  // useEffect(() => {
  //   if (authenticated) {
  //     if (user?.wallet) {
  //       navigate({ to: "/home" });
  //     } else {
  //       navigate({ to: "/onboarding" });
  //     }
  //   }
  // }, [authenticated, user, navigate]);
  //
  // // Don't render if authenticated (will redirect)
  // if (authenticated) {
  //   return null;
  // }

  return (
    <div className="flex-1 flex flex-col items-center justify-center">
      <Button
        className="mt-4 relative rounded-lg font-semibold text-white px-4 py-2"
        onClick={() => login()}
      >
        Sign-in to continue
      </Button>
    </div>
  );
}
